var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('a-spin',{class:_vm.$style['spin'],attrs:{"spinning":_vm.loading}}):_c('div',{class:_vm.$style['body']},[_c('AppAside',{class:_vm.$style['aside']}),_c('AppMain',{class:_vm.$style['main']})],1)}
var staticRenderFns = []

export { render, staticRenderFns }